module.exports = __webpack_public_path__ + "img/tcs-promo.1c94f36c.png";